import React, { useState } from "react";
import Layout from "../components/layout";
import { Form, Input, Row, Col, Select } from "antd";
import toast from "react-hot-toast";
import axios from "axios";

import "../index.css";
import { useNavigate } from "react-router-dom";
const { Option } = Select;

const AddUser = () => {
  const [user, setUser] = useState({
    prenom: "",
    nom: "",
    email: "",
    password: "",
    societe: "",
  });

  const { prenom, nom, email, password, societe } = user;

  const [accountType, setAccountType] = useState("");

  const Navigate = useNavigate();

  const onSubmitForm = async (e) => {
    const userData = {
      prenom: user.prenom,
      nom: user.nom,
      email: user.email,
      password: user.password,
      societe: user.societe,
      accountType: accountType,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/add-user`, userData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
          console.log(response.data.data);
          Navigate("/user-list");
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Layout>
      <h1 className="page-title">Ajouter Utilisateur</h1>
      <hr />
      <Form layout="vertical" onFinish={onSubmitForm}>
        <Row gutter={25}>
          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              required
              label="Prénom"
              name="prenom"
              rules={[{ require: true }]}
            >
              <Input
                placeholder="Prénom"
                name="prenom"
                value={prenom}
                onChange={(e) => setUser({ ...user, prenom: e.target.value })}
              />
            </Form.Item>
          </Col>

          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              required
              label="Nom"
              name="nom"
              rules={[{ require: true }]}
            >
              <Input
                placeholder="Nom"
                name="nom"
                onChange={(e) => setUser({ ...user, nom: e.target.value })}
              />
            </Form.Item>
          </Col>

          <Col span={12} xs={24} sm={24} lg={12}>
            <Form.Item
              required
              label="Société"
              name="societe"
              rules={[{ require: true }]}
            >
              <Input
                placeholder="Société"
                name="societe"
                onChange={(e) => setUser({ ...user, societe: e.target.value })}
              />
            </Form.Item>
          </Col>

          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              label="Choisir le type de compte (Admin, Utilisateur, Afl)"
              name="accountType"
              rules={[
                {
                  required: true,
                  message: "Please select account type (admin/user/afl)",
                },
              ]}
            >
              <Select
                value={accountType}
                placeholder="type de compte"
                onChange={(value) => setAccountType(value)}
              >
                <Option value="Admin">Admin</Option>
                <Option value="User">Utilisateur</Option>
                <Option value="Afl">Affilié</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter email",
                },
              ]}
            >
              <Input
                type="email"
                name="email"
                placeholder="Entrer l'adresse mail"
                required
                value={email}
                onChange={(e) => setUser({ ...user, email: e.target.value })}
              />
            </Form.Item>
          </Col>

          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter password",
                },
              ]}
            >
              <Input
                type="password"
                name="password"
                placeholder="Entrer le mot de passe"
                value={password}
                onChange={(e) => setUser({ ...user, password: e.target.value })}
              />
            </Form.Item>
          </Col>
        </Row>
        <button className="btn btn-primary" type="submit">
          Confirmer
        </button>
      </Form>
    </Layout>
  );
};

export default AddUser;

// https://youtu.be/eFqZNZLO6N0?list=PLv2XM6ZQzv_AtljUCwCCdi4fa2Go4ATZt&t=835 13:55
